export const navItems = [
  {
    id: 1,
    url: "how-it-works",
    item: "How It Works",
  },
  {
    id: 2,
    url: "faq",
    item: "FAQs",
  },
  {
    id: 3,
    url: "location",
    item: "Locations",
  },
  {
    id: 4,
    url: "terms-and-condition",
    item: "Terms and Conditions",
  },
];

export const ReasonsData = [
  {
    id: 1,
    title: "Contactless Pickup Points",
    content: "No more waiting around or missed calls.",
  },
  {
    id: 2,
    title: "Secure & Monitored",
    content: "Each locker is protected and access-controlled.",
  },
  {
    id: 3,
    title: "Always Available",
    content: "Open 24/7, even on weekends and public holidays",
  },
  {
    id: 4,
    title: "Fast & Trackable",
    content: "Get real-time updates when packages arrive",
  },
];

export const userData = [
  {
    id: 1,
    img: "images/pic1.png",
    field: " eCommerce Businesses",
    content: "Offer reliable last-mile delivery at no extra cost",
  },
  {
    id: 2,
    img: "images/pic2.png",
    field: "Online Shoppers",
    content: "Receive your orders safely at a nearby locker",
  },
  {
    id: 3,
    img: "images/pic3.png",
    field: " API-Integrated Partners",
    content: "Seamlessly route locker deliveries from your platform",
  },
  {
    id: 4,
    img: "images/pic4.png",
    field: "SMEs & Retailers",
    content: " Reduce failed deliveries and improve customer experience",
  },
];

export const faq = [
  {
    title: "What is SafeLocker?",
    description:
      "A SafeLocker is a 24/7 self-service parcel delivery service that allows for secure parcel collection with a one-time password (OTP).",
  },
  {
    title: "Are there size limits for packages?",
    description: `
            <p>Yes, our lockers come in 4 sizes:</p>
            <ul class="list-disc list-inside">
                <li>Extra Large: 35cm x 45cm x 35cm</li>
                <li>Large: 35cm x 45cm x 27cm</li>
                <li>Medium: 35cm x 45cm x 20cm</li>
                <li>Small: 35cm x 45cm x 8cm</li>
            </ul>
            <p class="mt-2">Ensure your packages fit within these dimensions.</p>
        `,
  },
  {
    title: "What's the cost of using a SafeLocker?",
    description:
      "Safe Lockers are charged at ₦1,500 for intrastate and ₦ 2,500 for interstate, with a 24-hour validity period for pick up. However, during the LockerDash campaign period, Safe locker within Lagos and Abuja will cost ₦699, and ₦2000 from any state to Lagos/Abuja.",
  },
  {
    title: "What happens if I exceed the 36-hour validity period?",
    description:
      "The package will be removed from the locker and taken to the nearest Fez delivery hub for the receiver to pick up (additional charges may apply). Please contact support for assistance.",
  },
  {
    title: "Where can I find my nearest SafeLocker?",
    description:
      "Click the link to view our SafeLocker locations and select based on proximity.",
  },
  {
    title: "How will I know when my parcel is ready for collection?",
    description:
      "Once your package arrives at the locker, you'll receive a notification with a unique one-time password (OTP) via email or SMS.",
  },
  {
    title: "What items can be sent through SafeLocker?",
    description:
      "Please refer to the terms and conditions section for a list of prohibited items. All parcels must be securely packaged and not exceed 35cm x 35cm x 45cm.",
  },
];

export const lagosLocations = [
  {
    area: "Osapa/Jakande",
    address: "Circle Mall - Shoprite Osapa, Jakande bus stop Lekki, Lagos",
    location: {
      name: "Circle Mall",
      position: {
        lat: 6.4383,
        lng: 3.5087,
      },
      address: "Lekki Toll Road, Lekki Penninsula II, Lekki",
      mapsLink:
        "https://www.google.com/maps?q=Circle+Mall,+Lekki,+Lagos,+Nigeria",
    },
  },
  {
    area: "Lekki Phase 1",
    address: "AP Filling Station - Admiralty way, Lekki Phase 1",
    location: {
      name: "Lekki Phase 1",
      position: {
        lat: 6.4475067,
        lng: 3.4644632,
      },
      address: "AP Filling Station - Admiralty way, Lekki Phase 1",
      mapsLink:
        "https://www.google.com/maps?q=Admiralty+Wy,+Eti-Osa,+Lekki+106104,+Lagos,+Nigeria",
    },
  },
  {
    area: "Oba Akran",
    address: "AP Filling Station - 39 Oba Akran Ave, Ikeja, Lagos",
    location: {
      name: "Oba Akran",
      position: {
        lat: 6.6017428,
        lng: 3.3327812,
      },
      address: "AP Filling Station - 39 Oba Akran Ave, Ikeja, Lagos",
      mapsLink:
        "https://www.google.com/maps?q=39+Oba+Akran+Ave,+Ikeja,+Lagos+101233,+Lagos,+Nigeria",
    },
  },
  {
    area: "Oniru",
    address: "AP Filling Station Oniru - Lekki Phase 1, Lagos",
    location: {
      name: "Oniru",
      position: {
        lat: 6.434723,
        lng: 3.4529156,
      },
      address: "AP Filling Station Oniru - Lekki Phase 1, Lagos",
      mapsLink:
        "https://www.google.com/maps?q=Ap+Filling+Station,+Oniru,+Lekki+Phase+1,+Nigeria",
    },
  },
  {
    area: "Ogba",
    address: "AP Filling Station - Oba Ogunji Road, Ogba, Lagos",
    location: {
      name: "Ogba",
      position: {
        lat: 6.6281063,
        lng: 3.3284174,
      },
      address: "AP Filling Station - Oba Ogunji Road, Ogba, Lagos",
      mapsLink: "https://www.google.com/maps?q=Oba+Ogunji+Rd,+Lagos,+Nigeria",
    },
  },
  // {
  //   area: "Falomo",
  //   address: "AP Filling Station - 221, Awolowo Road, Ikoyi, Lagos State",
  //   location: {
  //     name: "Falomo",
  //     position: {
  //       lat: 6.448862,
  //       lng: 3.4159985,
  //     },
  //     address: "AP Filling Station - 221, Awolowo Road, Ikoyi, Lagos State",
  //     mapsLink:
  //       "https://www.google.com/maps?q=AP+Filling+Station+-+221,+Awolowo+Road,+Ikoyi,+Lagos+State,+Nigeria",
  //   },
  // },
  {
    area: "Sangotedo",
    address:
      "Enyo Sangotedo - Lekki-Epe Express Way Oloko-NIa, Aja Eti-Osa, Lagos State",
    location: {
      name: "Sangotedo",
      position: {
        lat: 6.4488554,
        lng: 3.3387476,
      },
      address:
        "Enyo Sangotedo - Lekki-Epe Express Way Oloko-NIa, Aja Eti-Osa, Lagos State",
      mapsLink:
        "https://www.google.com/maps?q=Enyo+Sangotedo+-+Lekki-Epe+Express+Way+Oloko-NIa,+Aja+Eti-Osa,+Lagos+State,+Nigeria",
    },
  },
  {
    area: "Alapere",
    address:
      "AP Filling Station Alapere - Third Axial Rd Ojota 105102, Lagos State",
    location: {
      name: "Alapere",
      position: {
        lat: 6.5710505,
        lng: 3.3945137,
      },
      address:
        "AP Filling Station Alapere - Third Axial Rd Ojota 105102, Lagos State",
      mapsLink:
        "https://www.google.com/maps?q=Third+Axial+Rd,+Lagos,+Lagos,+Nigeria",
    },
  },
  {
    area: "University of Lagos (UNILAG)",
    address:
      "Unilag Petrol Station, G99R+GFR, Dan Fodio Blvd, University Of Lagos, 101245, Akoka - Lagos",
    location: {
      name: "University of Lagos (UNILAG)",
      position: {
        lat: 6.515759,
        lng: 3.3872698,
      },
      address:
        "Unilag Petrol Station, G99R+GFR, Dan Fodio Blvd, University Of Lagos, 101245, Akoka - Lagos",
      mapsLink:
        "https://maps.app.goo.gl/7bQ55q5gNj7HqP4C9",
    },
  },
  {
    area: "Pan Atlantic University (PAU)",
    address:
      "Pan - Atlantic University, Cooperative Queens Hostel",
    location: {
      name: "Pan Atlantic University (PAU)",
      position: {
        lat: 6.4826541,
        lng: 3.8527643,
      },
      address:
        "Pan - Atlantic University, Cooperative Queens Hostel",
      mapsLink:
        "https://maps.app.goo.gl/wRoX6JUE2DrgBcbY9",
    },
  },
  {
    area: "Festac",
    address: "AP Filling Station - 21 Road, Festac Town, Lagos State",
    location: {
      name: "Festac",
      position: {
        lat: 6.4677648,
        lng: 3.2891809,
      },
      address: "AP Filling Station - 21 Road, Festac Town, Lagos State",
      mapsLink:
        "https://www.google.com/maps?q=Circle+Mall,+Lekki,+Lagos,+Nigeria",
    },
  },
];

export const abujaLocations = [
  {
    area: "Apo",
    address: "AP Filling Station Apo - Opp GTBank, Along GUDU ROAD, Abuja",
    location: {
      name: "Apo",
      position: {
        lat: 6.4383,
        lng: 3.5087,
      },
      address: "AP Filling Station Apo - Opp GTBank, Along GUDU ROAD, Abuja",
      mapsLink:
        "https://www.google.com/maps?q=AP+Filling+Station+Apo+-+Opp+GTBank,+Along+GUDU+ROAD,+Abuja,+Nigeria",
    },
  },
  {
    area: "Maitama",
    address:
      "AP Filling Station Maitama - Aguiyi Ironsi Street, Opp Transcorp Hilton, Maitama, Abuja",
    location: {
      name: "Maitama",
      position: {
        lat: 9.0742854,
        lng: 7.492406,
      },
      address:
        "AP Filling Station Maitama - Aguiyi Ironsi Street, Opp Transcorp Hilton, Maitama, Abuja",
      mapsLink: "https://www.google.com/maps?q=Transcorp+Hilton+Abuja,+Nigeria",
    },
  },
];
